import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FormDataUpload, NestApiProvider } from '../../nest-api';
import {
  RequestCreateTicketDto,
  ResponseCreateTicketDto,
  ResponseMasterProblemCategoryDto,
  ResponseListProblemsDto,
  RequestCreatMessageDto,
  ResponseGetMessageDto,
  RequestListProblemsDto,
  RequestGetMessage,
} from '../dto/report-problems.dto';
import * as moment from 'moment';
import { ResponseData, ResponsePaging } from '../../nest-responses';

@Injectable()
export class ReportProblemsApi {

  private readonly service: string = '';
  private readonly model: string = 'reportproblems';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public masterProblemCategory(): Observable<ResponseMasterProblemCategoryDto> {
    const method: string = 'GET';
    const func: string = 'masterProblemCategory';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseMasterProblemCategoryDto>(method, url, params, urlParams, body);
  }

  public masterProblemCategoryWithoutToken(host: string): Observable<ResponseMasterProblemCategoryDto> {
    const method: string = 'GET';
    const func: string = 'masterProblemCategoryWithoutToken';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = `${host}/${this.model}/${func}`;
    // const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseMasterProblemCategoryDto>(method, url, params, urlParams, body);
  }

  public createTicket(payload: RequestCreateTicketDto): Observable<ResponseCreateTicketDto> {
    const method: string = 'POST';
    const func: string = 'createTicket';
    const params: FormDataUpload[] = [];

    Object.keys(payload).map(i => {
      if (i == 'file') {
        for (const item of payload[i]) {
          params.push({
            name: i,
            value: item,
            fileName: moment().valueOf() + '_' + ((Math.random() * 100) + 1) + '.jpg',
          })
        }
      } else {
        params.push({
          name: i,
          value: payload[i],
        })
      }
    });

    const urlParams: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.requestUpload<ResponseCreateTicketDto>(method, url, params);
  }

  public createTicketWithoutToken(payload: RequestCreateTicketDto, host: string): Observable<ResponseCreateTicketDto> {
    const method: string = 'POST';
    const func: string = 'createTicketWithoutToken';
    const params: FormDataUpload[] = [];

    Object.keys(payload).map(i => {
      if (i == 'file') {
        for (const item of payload[i]) {
          params.push({
            name: i,
            value: item,
            fileName: moment().valueOf() + '_' + ((Math.random() * 100) + 1) + '.jpg',
          })
        }
      } else {
        params.push({
          name: i,
          value: payload[i],
        })
      }
    });

    const url = `${host}/${this.model}/${func}`;
    // const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.requestUpload<ResponseCreateTicketDto>(method, url, params);
  }

  listReportProblem(queryParams: RequestListProblemsDto) {
    const method: string = 'GET';
    const func: string = 'listReportProblem';
    const params = {};
    const urlParams: any = queryParams;
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePaging<ResponseListProblemsDto>>(method, url, params, urlParams, body);
  }

  getNotifMessage() {
    const method: string = 'GET';
    const func: string = 'getNotifMessage';
    const params = {};
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body, null, null, null, false);
  }

  getMessage(payload: RequestGetMessage) {
    const method: string = 'GET';
    const func: string = 'getMessage';
    const params = {};
    const urlParams: any = payload;
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePaging<ResponseGetMessageDto>>(method, url, params, urlParams, body);
  }

  createmessage(payload: RequestCreatMessageDto) {
    const method: string = 'POST';
    const func: string = 'createmessage';
    const urlParams: any = {};
    // const body: any = {};
    const params: FormDataUpload[] = [];

    for (let key in payload) {
      params.push({ name: key, value: payload[key] })
    }

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestUpload<ResponseCreateTicketDto>(method, url, params);
  }

  urlCeatemessage() {
    const method: string = 'POST';
    const func: string = 'createmessage';
    const urlParams: any = {};
    const params: any = {}

    return this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-all-in-one/services/report-problems.api.ts